/** Presentation helpers for the Drive index page. */

/**
 * Seconds as wall-clock time — "7m 11s", "1h 12m", "3d 4h".
 *
 * Wall clock rather than a raw seconds count because the question this page
 * answers is "how old is what I am looking at", and nobody reads 158_400 as
 * "yesterday". Rounds to two units: the third never changes a decision.
 */
export const formatDuration = (seconds?: number | null): string => {
  if (seconds === undefined || seconds === null) return '—';
  if (seconds < 0) return '—';

  const total = Math.round(seconds);
  if (total < 60) return `${total}s`;

  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes}m ${total % 60}s`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ${minutes % 60}m`;

  return `${Math.floor(hours / 24)}d ${hours % 24}h`;
};

/** Byte counts, base 1024 — the cache is sized in binary units. */
export const formatBytes = (bytes?: number | null): string => {
  if (bytes === undefined || bytes === null) return '—';
  if (bytes < 1024) return `${bytes} B`;

  const units = ['KiB', 'MiB', 'GiB', 'TiB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value < 10 ? 1 : 0)} ${units[unit]}`;
};

/** Whole counts with thousands separators; `undefined` reads as unknown, not 0. */
export const formatCount = (count?: number | null): string =>
  count === undefined || count === null ? '—' : count.toLocaleString('en-US');
